export const STATUSES = Object.freeze({
  DEFAULT: 'default',
  REJECTED: 'rejected',
  PENDING: 'pending',
  APPROVED: 'approved',
});

export const APPROVAL_NOTIFICATION_TITLES = Object.freeze({
  APPROVED: 'Approved for Offer',
  APPLICATION_APPROVED: 'Offer Application Approved',
  DENIED: 'Offer Application Denied',
});

export const BUTTON_TEXT = Object.freeze({
  REQUEST_APPROVAL: 'Request Approval',
  NEED_HELP: 'Need Help',
  CREATE_A_NEW_ZONE: 'Create a new zone',
});

export const BUTTON_TEXT_BY_STATUS = Object.freeze({
  [STATUSES.DEFAULT]: BUTTON_TEXT.REQUEST_APPROVAL,
  [STATUSES.PENDING]: BUTTON_TEXT.NEED_HELP,
  [STATUSES.REJECTED]: BUTTON_TEXT.NEED_HELP,
  [STATUSES.APPROVED]: BUTTON_TEXT.NEED_HELP,
});

export const VAST_PREROLL_PATH = 'vast-pre-roll';

export const filterVastUrlInNotifactions = (alerts) => {
  if (!USE_VAST_PREROLL || !alerts?.length) {
    return alerts;
  }

  alerts = alerts.map((alert) => {
    const { description, title } = alert;

    const createLink = (denied) => {
      let text = 'You have been approved for the Pre-roll promo tool.';

      if (denied) {
        text = 'You have been refused for the Pre-roll promo tool.';
      }

      const link = `<a href="/${VAST_PREROLL_PATH}">${text}</a>`;

      return link;
    };

    if (
      description?.toLowerCase()?.includes('vast pre-roll') &&
      (title === APPROVAL_NOTIFICATION_TITLES.APPROVED || title === APPROVAL_NOTIFICATION_TITLES.APPLICATION_APPROVED)
    ) {
      alert.description = createLink();
    } else if (description?.toLowerCase()?.includes('vast pre-roll') && title === APPROVAL_NOTIFICATION_TITLES.DENIED) {
      alert.description = createLink(true);
    }

    return alert;
  });

  return alerts;
};

export const USE_VAST_PREROLL = process.env.REACT_APP_USE_VAST_PREROLL === 'true';

export const VAST_PROMO_METHOD_SELECT_DEFAULT_VALUE = 'Pre-rolls';
